module.exports = __webpack_public_path__ + "static/img/6.a1b96aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/6.png
// module id = 2nGX
// module chunks = 0